import stats from '@/components/stats/Stats'

export default [
  {
    path: '/stats',
    name: 'stats',
    component: stats,
    meta: {
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/stats.js